import { createGlobalStore } from 'hox';
import { useState } from 'react';
import config from 'src/config';

function useGlobalSetting() {
  const [selectedOrgGlobalSetting, setSelectedOrgGlobalSetting] = useState<{
    [key: string]: boolean | number;
  }>({});
  const [isGlobalSettingLoaded, setIsGlobalSettingLoaded] = useState(false);

  // const [groupGlobalSetting, setGroupGlobalSetting] = useState<{
  //   [key: string]: boolean | number;
  // }>({});

  const overwriteSelectedOrgGlobalSetting = (setting: {
    [key: string]: boolean | number;
  }) => {
    Object.keys(config.ui.featureToggle).forEach((key) => {
      if (
        config.ui.featureToggle &&
        (config.ui.featureToggle as any)[key] === true
      ) {
        setting[key] = (config.ui.featureToggle as any)[key];
      } else if (setting[key] === undefined) {
        setting[key] = false;
      }
      //other key is setting self value
    });
    console.log('turnOnSetting', setting);
    setSelectedOrgGlobalSetting(setting);
    setIsGlobalSettingLoaded(true);
    localStorage.setItem('casCurOrgGlobalSetting', JSON.stringify(setting));
  };

  return {
    setSelectedOrgGlobalSetting: overwriteSelectedOrgGlobalSetting,
    selectedOrgGlobalSetting,
    isGlobalSettingLoaded,
  };
}
export const [useGlobalSettingStore] = createGlobalStore(useGlobalSetting);
